import React from 'react';
import { Box, BoxProps } from '../../../Box';
import { dataTableClassnames } from '../const/classNames';
import { DataTableStyles } from '../styles/Styles';

export interface WrapperProps extends Omit<BoxProps, 'ref'> {
  slots?: {
    top?: React.ReactNode;
    bottom?: React.ReactNode;
  };
}

export const Wrapper: React.FC<WrapperProps> = ({ children, slots, ...rest }) => {
  return (
    <DataTableStyles {...rest}>
      <Box className={dataTableClassnames.slots.top}>{slots?.top}</Box>
      <Box className={dataTableClassnames.slots.children}>{children}</Box>
      <Box className={dataTableClassnames.slots.bottom}>{slots?.bottom}</Box>
    </DataTableStyles>
  );
};
